import { render } from "./account_actions.vue?vue&type=template&id=275782b2"
import script from "./account_actions.js?vue&type=script&lang=js"
export * from "./account_actions.js?vue&type=script&lang=js"

import "./account_actions.vue?vue&type=style&index=0&id=275782b2&lang=scss"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__